/**
 * Route map.
 *
 *   Public:  /login, /auth/callback, /access-denied
 *   Gated  : everything else, behind <RequireSuperAdmin> inside the <Layout> shell.
 */
import type { ReactNode } from "react";
import { Route, Routes } from "react-router-dom";
import { RequireSuperAdmin } from "./auth/RequireSuperAdmin";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { AuthCallbackPage } from "./pages/AuthCallbackPage";
import { AccessDeniedPage } from "./pages/AccessDeniedPage";
import { DashboardPage } from "./pages/DashboardPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { InvitationsPage } from "./pages/InvitationsPage";
import { AccessRequestsPage } from "./pages/AccessRequestsPage";
import { UsersPage } from "./pages/UsersPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { OrgsPage } from "./pages/OrgsPage";
import { OrgDetailPage } from "./pages/OrgDetailPage";
import { CategoriesPage } from "./pages/CategoriesPage";
import { CategoryDetailPage } from "./pages/CategoryDetailPage";
import { CatalogEntriesPage } from "./pages/CatalogEntriesPage";
import { ResolvedCatalogPage } from "./pages/ResolvedCatalogPage";
import { AuditPage } from "./pages/AuditPage";

export function App(): ReactNode {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/access-denied" element={<AccessDeniedPage />} />

      {/* super_admin-gated routes inside the app shell */}
      <Route element={<RequireSuperAdmin />}>
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailPage />} />
          <Route path="orgs" element={<OrgsPage />} />
          <Route path="orgs/:id" element={<OrgDetailPage />} />
          <Route path="invitations" element={<InvitationsPage />} />
          <Route path="access-requests" element={<AccessRequestsPage />} />
          <Route path="catalog" element={<CategoriesPage />} />
          <Route path="catalog/:key" element={<CategoryDetailPage />} />
          <Route path="catalog/:key/entries" element={<CatalogEntriesPage />} />
          <Route path="catalog/:key/resolved" element={<ResolvedCatalogPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
